import YTPlayer from 'yt-player'

(function ($) {


    $(document).ready(function () {

        $('.video-inner').each(function (index, item) {
            var playerVrap = $(item).find('.video-youtube');

            if(playerVrap.length > 0) {
                var player = new YTPlayer('#' + playerVrap.attr("id") + '', {
                    controls: true,
                    annotations: false,
                    captions: false,
                    related: false,
                    modestBranding: false,
                    playsInline  : false,
                    timeupdateFrequency : false,
                });

                let videoID = $(this).attr('data-video');

                player.load(videoID)

                player.on('playing', () => {
                    console.log('play')
                    $(item).find('.logo-play').fadeOut(300);
                    $(item).find('.image-video').fadeOut(300);
                    // $(item).find('.logo-pause').fadeIn(300);

                })
                player.on('paused', () => {
                    console.log('pause')
                    // $(item).find('.logo-pause').fadeOut(300);
                    // $(item).find('.logo-play').fadeIn(300);
                })

                $(item).find('.logo-play').on('click', function () {
                    player.play();
                })

                $(item).closest('.item_posts_for_video').find('.text_button').on('click', function () {
                    player.play();
                })

                $(item).find('logo-pause').on('click', function () {
                    player.pause();
                })
            }
        });


    });
})(jQuery);
